export const hasEnvironment = (data, envID) => {
    for (let e of data.env) {
        if (e.envID === envID) {
            return true;
        }
    }

    return false;
};

export const getEnvironmentTypes = (envs) => {
    let ret = [];
    for (let e of envs) {
        if (!ret.includes(e.envType)) {
            ret.push(e.envType);
        }
    }
    return ret;
};

//dataリストを走査し、要素名がkeyの要素についてvalueと等しいかのboolテーブルを作成する
export const areEqual = (data, key, value) => {
    let ret = [];
    if (!data) {
        return ret;
    }

    data.forEach((e, index) => {
        if (e[key] === value) {
            ret.push(true);
        } else {
            ret.push(false);
        }
    });

    return ret;
};

//regionIDに属する環境情報を取得する
export const getRegionEnvironment = (regions, regionID) => {
    let ret;
    regions.forEach((region, index) => {
        if (region.regionID === regionID) {
            ret = region.env;
        }
    });

    return ret;
};

export const getHyperParameter = (hyperParams, hyperParamID) => {
    for (let h of hyperParams) {
        if (h.hyperParamID === hyperParamID) {
            return h;
        }
    }
};
